<template>
  <BaseChoice
    title="関連付けるクラスを選択してください"
    resourceType="class"
    :fields="fields"
    :items="tamai_class.tamaiClasses"
    :totalItems="totalTamaiClasses"
    :isFetching="isFetching"
  />
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import BaseChoice from '@/views/choices/Base.vue';
import { basicFieldPresent } from '@/presenters/fields';

export default {
  data() {
    return {
      isFetching: false,
    };
  },
  components: {
    BaseChoice,
  },
  mounted() {
    let filterBy = {};

    if (this.prevFormData.corporation) {
      filterBy.corporationId = this.prevFormData.corporation.id;
    }

    if (this.prevFormData.brand) {
      filterBy.brandId = this.prevFormData.brand.id;
    }

    if (this.prevFormData.school) {
      filterBy.schoolId = this.prevFormData.school.id;
    }

    if (this.prevFormData.course) {
      filterBy.courseId = this.prevFormData.course.id;
    }

    this.$logger.debug('Start fetching Class for Choices');
    this.clearTamaiClasses();
    this.isFetching = true;
    this.fetchTamaiClasses({ data: { filterBy } }).then(() => {
      this.isFetching = false;
      this.$logger.debug('Done fetching Class for Choices');
    });
  },
  computed: {
    fields() {
      return [
        {
          key: 'course',
          label: 'コース名',
          sortable: true,
          thAttr: { width: 300 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return basicFieldPresent(value, 'name');
          },
        },
        {
          key: 'name',
          label: 'クラス名',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'mainTeacher',
          label: '先生名（担当・メイン）',
          sortable: true,
          thAttr: { width: 250 },
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return basicFieldPresent(value, 'name');
          },
        },
        {
          key: 'choiceResource',
          label: '選択',
          sortable: false,
          thAttr: { width: 60 },
        },
      ];
    },
    ...mapState(['tamai_class']),
    ...mapGetters('tamai_class', ['totalTamaiClasses']),
    ...mapState('form', ['prevFormData']),
  },
  methods: {
    ...mapActions('tamai_class', ['fetchTamaiClasses', 'clearTamaiClasses']),
  },
};
</script>
